import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { isNumber } from '../../functions';
import { MaskToggleDirective } from '../directives';

export interface IBaseInputMask {
  maskPattern: string | null;
  showMaskPattern: boolean | null;
  clearForModel: boolean | null;
  placeHolderChar: string | null;
  delimiterChar: string;
  suffix: string | null;
  prefix: string;
  specialCharacters: string[];
}

export interface IInputMask extends IBaseInputMask {
  type: 'default';
}

export interface INumericInputMask extends IBaseInputMask {
  type: 'numeric';
  numOfDigits: number | null;
  decimalMarker: string | null;
  allowNegativeNumbers: boolean;
}

const NUMERIC_CHAR = '0';

export function defaultMask(): IInputMask {
  return {
    type: 'default',
    maskPattern: '',
    showMaskPattern: false,
    clearForModel: true,
    placeHolderChar: '_',
    delimiterChar: '',
    suffix: '',
    prefix: '',
    specialCharacters: []
  };
}

export function defaultNumericMask(): INumericInputMask {
  return {
    type: 'numeric',
    numOfDigits: null,
    maskPattern: null,
    showMaskPattern: null,
    clearForModel: null,
    placeHolderChar: null,
    delimiterChar: '',
    decimalMarker: null,
    allowNegativeNumbers: false,
    suffix: null,
    prefix: '',
    specialCharacters: []
  };
}

export function numericMask(partialMask?: Partial<INumericInputMask>): INumericInputMask {
  if (isNumber(partialMask?.numOfDigits)) {
    partialMask = { ...partialMask, ...{ maskPattern: NUMERIC_CHAR.repeat(partialMask.numOfDigits) } };
  }

  const numMask = {
    ...defaultNumericMask(),
    numOfDigits: 0,
    clearForModel: true,
    showMaskPattern: false,
    ...partialMask
  };
  return numMask;
}

export function currencyMask(partialMask?: Partial<INumericInputMask>): INumericInputMask {
  return {
    ...defaultNumericMask(),
    maskPattern: 'separator',
    ...partialMask,
    prefix: '₪',
    delimiterChar: ',',
    showMaskPattern: false,
    clearForModel: true
  };
}

export function dateMask(partialMask?: Partial<IInputMask>): IInputMask {
  const m = {
    ...defaultMask(),
    showMaskPattern: true,
    maskPattern: '00/00/0000',
    clearForModel: false,
    ...partialMask
  };

  return m;
}

export function shortDateMask(partialMask?: Partial<IInputMask>): IInputMask {
  return dateMask({ maskPattern: 'M0/00' });
}

function phoneMask(partialMask?: Partial<IInputMask>): IInputMask {
  return {
    ...defaultMask(),
    showMaskPattern: true,
    clearForModel: false,
    ...partialMask
  };
}

export function landlinePhoneMask(partialMask?: Partial<IInputMask>): IInputMask {
  return phoneMask({ ...partialMask, maskPattern: '00-0000000' });
}

export function mobilePhoneMask(partialMask?: Partial<IInputMask>): IInputMask {
  return phoneMask({ ...partialMask, maskPattern: '000-0000000' });
}

export const MaskingImportPack = [NgxMaskDirective, MaskToggleDirective] as const;
export const provideMasking = provideNgxMask;
